import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const QuestionIcon = (props) => {
  return (
    <SvgIcon width="14" height="14" {...props} viewBox="0 0 14 14">
      <path id="ic_help_outline_24px" d="M8.3,13.2H9.7V11.8H8.3ZM9,2a7,7,0,1,0,7,7A7,7,0,0,0,9,2ZM9,14.6A5.6,5.6,0,1,1,14.6,9,5.607,5.607,0,0,1,9,14.6ZM9,4.8A2.8,2.8,0,0,0,6.2,7.6H7.6a1.4,1.4,0,0,1,2.8,0c0,1.4-2.1,1.225-2.1,3.5H9.7c0-1.575,2.1-1.75,2.1-3.5A2.8,2.8,0,0,0,9,4.8Z" transform="translate(-2 -2)" fill="#7f7f7f"/>
    </SvgIcon>
  );
};

QuestionIcon.propTypes = {}

QuestionIcon.defaultProps = {}

export default QuestionIcon;
